export const environment: {
  production: boolean;
  buildNumber: string;
  baseScmApiUrl: string;
  clientId: string;
  authority: string;
  redirectUrl: string;
  signInAuthority: string;
  signInName: string;
  passwordResetAuthority: string;
  passwordResetName: string;
  b2cScope: string;
  webApi: string;
  dashUrl: string;
  favIcon: string;
  claimSummaryPopupPath: string;
} = {
  production: false,
  buildNumber: '3.0.53',
  favIcon: 'favicon.ico',

  // saas api
  claimSummaryPopupPath: 'https://sit0h9on1k.execute-api.us-east-1.amazonaws.com/dev/widget/claim-stream-widget.html',

  // crm api
  baseScmApiUrl: 'https://brnz3nvnpc.execute-api.us-east-1.amazonaws.com/dev',

  // b2c
  clientId: '2dcf5b96-65a0-4d50-936a-3f9cd0bafb8c',
  authority: 'https://login.microsoftonline.com/194a267b-82ba-4fa6-b6b9-f95966ab3815/',
  redirectUrl: 'https://newleaf-crm-dev.csgfsm.com',
  signInAuthority: 'https://CSGB2CDEV.b2clogin.com/CSGB2CDEV.onmicrosoft.com/B2C_1_Signin',
  signInName: 'B2C_1_Signin',
  passwordResetAuthority:
    'https://CSGB2CDEV.b2clogin.com/CSGB2CDEV.onmicrosoft.com/B2C_1_PasswordReset',
  passwordResetName: 'B2C_1_PasswordReset',
  b2cScope: 'https://CSGB2CDEV.onmicrosoft.com/helloapi/demo.read',
  webApi: 'https://CSGB2CDEV.onmicrosoft.com/2dcf5b96-65a0-4d50-936a-3f9cd0bafb8c/retrieve',

  // other services
  dashUrl: 'https://csgi-newleaf.domo.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
